export default {
  Products: 'Products',
  EditProduct: 'EditProduct',
  ShowProduct: 'ShowProduct',
  MergeProducts: 'MergeProducts',
  UnmergeProduct: 'UnmergeProduct',
  CreateBundle: 'CreateBundle',
  Unbundle: 'Unbundle',
  AddToBundle: 'AddToBundle',
  RemoveFromBundle: 'RemoveFromBundle',
  ProductDetailsPlaceholder: 'ProductDetailsPlaceholder',
  ProductDetails: 'ProductDetails'
}
